import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Tooltip } from "primereact/tooltip";

// Custom components
import NoData from "../NoData";

// Utils
import { hasPendingChange, pendingChangeTooltip, requestModalModeOptions } from "./utils";

//Styles
import myStyles from "../../styles/appointments/Appointments.module.css"
import { LogWarning } from "../../helpers/logger";

export default function AppointmentsCalendarRecurringControllers({
  controllers,
  onEditController,
  openCancelConfirmation,
  loadingAppointmentsSmall,
  getOrgNameFromMap,
}) {
  const splitLocalFrequency = (frequency) => {
    if (!frequency) {
      return frequency;
    }

    const splitFrequency = frequency.split(" | ");
    if (splitFrequency.length < 3) {
      LogWarning("Could not split frequency string into 3 parts", { frequency });
      return frequency;
    }

    const lineOne = splitFrequency[0] + " | " + splitFrequency[1];
    const lineTwo = splitFrequency[2];

    return (
      <>
        {lineOne}
        <br />
        {lineTwo}
      </>
    );
  }

  return (
    <div className={myStyles.calendarViewApptsContainer}>

      {controllers?.length === 0 && (
        <NoData
          title={"Nothing here... yet"}
          subTitle={"Data will be displayed here when available"}
        />
      )}


      {controllers.map((controller, i) => {
        return (
          <div
            key={i}
            className={myStyles.calendarViewControllers}
          >
            <b>
              {splitLocalFrequency(controller.localFrequency)}
            </b>

            <div className="flex flex-column gap-0">
              <div className="flex flex-row flex-wrap gap-1">
                Date range:
              </div>
              <div className="flex flex-row flex-wrap gap-1">
                <span className={myStyles.purpleText}>{new Date(controller.startDate).toLocaleDateString()}</span>
                -
                <span className={myStyles.purpleText}>{new Date(controller.endDate).toLocaleDateString()}</span>
              </div>
            </div>

            <div className="flex flex-column gap-0">
              <div className="flex flex-row flex-wrap gap-1">
                with
                <span className={myStyles.purpleText}>{controller.staff}</span>
              </div>
              <div className="flex flex-row flex-wrap gap-1">
                from
                <span className={myStyles.purpleText}>{getOrgNameFromMap(controller.orgId)}</span>
              </div>
            </div>

            <div className="flex flex-row flex-wrap gap-2">
              {hasPendingChange(controller) && (
                <div className={myStyles.infoWithTooltip}>
                  <Tooltip target={`#change_button_info_${controller.id}`} />
                  <i
                    id={`change_button_info_${controller.id}`}
                    className="pi pi-info-circle"
                    style={{ fontSize: '1.2rem' }}
                    data-pr-tooltip={pendingChangeTooltip}
                    data-pr-position="left"
                  />
                </div>
              )}
              <Button
                label="Change"
                className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
                onClick={() => {
                  onEditController(controller, requestModalModeOptions.change);
                }}
                disabled={hasPendingChange(controller) || loadingAppointmentsSmall}
              />
              <Button
                label="Cancel"
                severity="secondary"
                className={classNames(myStyles.calenderListButton, myStyles.roundedDialogButton)}
                onClick={() => openCancelConfirmation(controller)}
                disabled={hasPendingChange(controller) || loadingAppointmentsSmall}
              />
            </div>

            {i < controllers.length - 1 && (
              <hr className="mt-3 mb-3" />
            )}

          </div>
        )
      })}
    </div>
  )
}
